module.exports = __webpack_public_path__ + "static/media/svg-4.9d001e0d.svg";